"use strict";
/**
 * 公共素材库路由
 */
angular.module("resCenterPMLRouterModule", []).config(['$stateProvider', function($stateProvider) {
    $stateProvider.state("front.resourcectrl.materials.resource", {
        url: '/resource?nodeid&nodename&change&parentid',
        views: {
            'resource@front.resourcectrl.materials': {
                templateUrl: './resourceCenter/publicMaterialLibrary/materials_tpl.html',
                controller: 'resourceCenterMaterialsCtrl'
            }
        }
    })
}]);